/**
 * Area of interest: the zone is cut into square cells, and a client is told
 * about the entities in its own cell and the eight around it. Everything
 * further away does not exist for that client until it comes closer.
 *
 * Cells rather than a radius because membership only changes when someone
 * crosses a cell edge, which is rare compared to a tick, and because
 * "same or neighbouring cell" is one subtraction per axis.
 */
/**
 * Cell edge in tiles. The worst case for a player standing on a cell edge is
 * a guaranteed radius of one cell, so this must cover half the widest viewport:
 * at zoom 3 a 2 300 px screen shows ~48 tiles, half of which is 24.
 */
export const INTEREST_CELL_TILES = 24;
export function cellOf(tile, cellTiles = INTEREST_CELL_TILES) {
    return { cx: Math.floor(tile.x / cellTiles), cy: Math.floor(tile.y / cellTiles) };
}
/** Stable key for a cell, for maps and change detection. */
export function cellKey(cell) {
    return `${String(cell.cx)}:${String(cell.cy)}`;
}
/** True when the two cells are the same or touch, corners included. */
export function cellsAreNeighbours(a, b) {
    return Math.abs(a.cx - b.cx) <= 1 && Math.abs(a.cy - b.cy) <= 1;
}
/** True when `b` should be visible to something standing on `a`, and vice versa. */
export function isWithinInterest(a, b, cellTiles = INTEREST_CELL_TILES) {
    return cellsAreNeighbours(cellOf(a, cellTiles), cellOf(b, cellTiles));
}
//# sourceMappingURL=interest.js.map